import { takeEvery } from 'redux-saga/effects';

import { load } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenLoad() {
  yield takeEvery(load.toString(), customPrices.load);
}
